export const EVENTS = {
  CHECKOUT: {
    checkoutOpen: 'n3o:cart:checkout:open',    
    checkoutClose: 'n3o:cart:checkout:close',    
  },
  CARTCOUNTER: {
    refresh: 'n3o:cart-count:refresh', 
    requstCart: 'n3o:cart:request'
  }
}